import { http } from '@/api/http'
import { toListParams, type ListQuery } from '@/api/query'
import type { AccessResource, ClientType, ListResponse, MenuItem, MobileExperience, PermissionCatalogItem, RecordTable } from '@/types/api'
import type { RequestOptions } from '../crud'

export const accessService = {
  async resources(options?: RequestOptions) {
    const { data } = await http.get<AccessResource[]>('/access-resources', options)
    return data ?? []
  },
  async permissions(options?: RequestOptions) {
    const { data } = await http.get<PermissionCatalogItem[]>('/permissions', options)
    return data ?? []
  },
  /** The company's whole admin menu tree, unfiltered (the role editor groups rights by it). */
  async menu(options?: RequestOptions) {
    const { data } = await http.get<MenuItem[]>('/menu-items', options)
    return data ?? []
  },
  /** The tables «Записи» rules filter, their fields and ready-made rules. */
  async recordTables(options?: RequestOptions) {
    const { data } = await http.get<RecordTable[]>('/record-rules/tables', options)
    return data ?? []
  },
  async mobileExperiences(options?: RequestOptions) {
    const { data } = await http.get<MobileExperience[]>('/mobile-experiences', options)
    return data ?? []
  },
}

/** Client types are a fixed, system-owned catalog: read only. */
export const clientTypesService = {
  path: 'client-types',
  async list(query?: ListQuery, options?: RequestOptions) {
    const { data } = await http.get<ListResponse<ClientType>>('/client-types', {
      params: toListParams(query),
      ...options,
    })
    return { count: data.count ?? 0, items: data.items ?? [] }
  },
  async get(id: string, options?: RequestOptions) {
    const { data } = await http.get<ClientType>(`/client-types/${encodeURIComponent(id)}`, options)
    return data
  },
}
